import { Card, ListGroup, Button, Row, Col } from "solid-bootstrap"

function TOCEntry(props) {
    const doOnClick = () => {
        props.setStageName(props.stageName);
    };
    return <>
        <Show when={props.activeStage === props.stageName}>
            <ListGroup.Item action active onClick={doOnClick}>
                {props.title}
            </ListGroup.Item>
        </Show>
        <Show when={props.activeStage !== props.stageName}>
            <ListGroup.Item action onClick={doOnClick}>
                {props.title}
            </ListGroup.Item>
        </Show>
    </>;
}

// export function hrefForStage(device, stageName) {
//     if (!stageName) {
//         return null;
//     }
//     return `/device/${device.uuid}/setup/${stageName}`;
// }

function stageList() {
    return ["googlemaps", "locale", "themepreset", "theme", "soundoptions", "systemoptions", "googlecalendar"];
}

function firstStage() {
    return stageList()[0];
}

function lastStage() {
    return stageList()[stageList().length - 1];
}

function displayNames() {
    return {
        "googlemaps": "Device location",
        "locale": "Locale and language",
        "themepreset": "Choose theme",
        "theme": "Customise theme",
        "soundoptions": "Sound options",
        "systemoptions": "System options",
        "googlecalendar": "Link Google Calendar"
    }
}

function displayNameForStage(stageName) {
    if (!stageName) {
        return null;
    }
    return displayNames()[stageName];
}

function nextStage(stageName) {
    if (!stageName) {
        return null;
    }
    // Find the next stage using stageList()
    const stages = stageList();
    const index = stages.indexOf(stageName);
    if (index === -1) {
        return null;
    }
    if (index === stages.length - 1) {
        return null;
    }
    return stages[index + 1];
}

function previousStage(stageName) {
    if (!stageName) {
        return null;
    }
    // Find the previous stage using stageList()
    const stages = stageList();
    const index = stages.indexOf(stageName);
    if (index === -1) {
        return null;
    }
    if (index === 0) {
        return null;
    }
    return stages[index - 1];
}

export function PreviousButton(props) {
    const doOnClick = () => {
        props.setStageName(previousStage(props.stageName));
    };
    return <Show when={props.stageName != firstStage()}>
        <Button onClick={doOnClick}>Previous ({displayNameForStage(previousStage(props.stageName))})</Button>
    </Show>;
}

export function NextButton(props) {
    const doOnClick = () => {
        props.setStageName(nextStage(props.stageName));
    };
    return <Show when={props.stageName != lastStage()}>
        <Button onClick={doOnClick}>Next ({displayNameForStage(nextStage(props.stageName))})</Button>
    </Show>;
}

export function SetupTOCCard(props) {
    return <Card>
        <Card.Body>
            <Card.Title>Setup {props.device.nickname}</Card.Title>
            <Card.Text>
                <Row>
                    <Col xs={12} md={3}>
                        <ListGroup variant="flush">
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="googlemaps" title="1. Device location" />
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="locale" title="2. Locale and language" />
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="themepreset" title="3. Choose theme" />
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="theme" title="4. Customise theme" />
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="soundoptions" title="5. Sound options" />
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="systemoptions" title="6. System options" />
                            <TOCEntry device={props.device} activeStage={props.stageName} setStageName={props.setStageName} stageName="googlecalendar" title="7. Link Google Calendar" />
                        </ListGroup>
                    </Col>
                </Row>
            </Card.Text>
        </Card.Body>
    </Card>
}